import * as React from 'react'
import { getDisplayLabel } from '../utils'

interface WorkspaceIconProps {
    workspace: {
        id: string
        name: string
    }
    isActive: boolean
    onClick: () => void
    className?: string
    ariaLabel?: string
}

const WorkspaceIcon: React.FC<WorkspaceIconProps> = ({ workspace, isActive, onClick, className = '', ariaLabel }) => {
    const workspaceName = getDisplayLabel(workspace.name, 'Untitled workspace')
    const isDefault = workspace.name.trim() === 'Default'
    const activeClasses = 'border border-accent bg-accent/5 text-content shadow-sm'
    const inactiveClasses = 'border border-transparent bg-surface-secondary text-content-secondary hover:border-secondary hover:bg-hover hover:text-content'

    if (isDefault) {
        return (
            <button
                type="button"
                onClick={onClick}
                className={`flex h-11 w-11 items-center justify-center rounded-xl transition-colors ${isActive ? activeClasses : inactiveClasses} ${className}`}
                aria-label={ariaLabel || workspaceName}
                title={workspaceName}
            >
                <img
                    src="/logos/flowium_icon.svg"
                    alt={workspaceName}
                    className="h-6 w-6"
                />
            </button>
        )
    }

    return (
        <button
            type="button"
            className={`flex h-11 w-11 items-center justify-center rounded-xl font-semibold transition-colors ${isActive ? activeClasses : inactiveClasses} ${className}`}
            onClick={onClick}
            aria-label={ariaLabel || workspaceName}
            title={workspaceName}
        >
            <span className="text-sm">
                {workspaceName.charAt(0).toUpperCase()}
            </span>
        </button>
    )
}

export default WorkspaceIcon
